/* ============================================================================
   card-product-grow.js — grow-some
   Quick-add для кнопки .gp-card-cart на картках card-product-grow.liquid.

   POST /cart/add.js (variant із data-variant-id, qty 1) → Section Rendering
   API (sections=cart-drawer,cart-icon-bubble) → cart.renderContents() —
   той самий флоу, що в assets/product-form.js (Dawn), тож drawer відкривається
   і прогрес-бар безкоштовної доставки перераховується.

   Делегований слухач на document + guard window.__gpCardCartBound:
   asset можна підключати з кількох секцій на одній сторінці — обробник
   реєструється один раз, і працює для карток, домальованих пізніше
   (пагінація/фільтри колекції перерендерюють грід).
   ============================================================================ */
(function () {
  if (window.__gpCardCartBound) return;
  window.__gpCardCartBound = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.gp-card-cart[data-variant-id]');
    if (!button) return;

    // Mat-selector товари (data-mat-limit > 0) вимагають вибору килимків —
    // ними опікується gs-quick-pads.js (відкриває дравер). Тут їх ігноруємо,
    // щоб не додати набір без обовʼязкових килимків.
    if (parseInt(button.dataset.matLimit, 10) > 0) return;

    // Кнопка живе всередині <a> картки — глушимо перехід на product page.
    event.preventDefault();

    if (button.getAttribute('aria-disabled') === 'true') return;
    button.setAttribute('aria-disabled', 'true');

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    var body = new FormData();
    body.append('id', button.dataset.variantId);
    body.append('quantity', '1');
    if (cart) {
      body.append(
        'sections',
        cart.getSectionsToRender().map(function (section) { return section.id; })
      );
      body.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(button);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: body,
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          // /cart/add.js повернув помилку (наприклад, варіант щойно розкупили).
          if (window.publish && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'card-product-grow',
              productVariantId: button.dataset.variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          console.error('[card-product-grow] cart add failed:', response.description || response.message);
          return;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (window.publish && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'card-product-grow',
            productVariantId: button.dataset.variantId,
            cartData: response,
          });
        }
        cart.renderContents(response);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      })
      .catch(function (error) {
        console.error('[card-product-grow]', error);
      })
      .finally(function () {
        button.removeAttribute('aria-disabled');
      });
  });
})();
